<template>
    <div class="reo-plan-message">
        <table cellpadding="0" cellspacing="0">
            <tbody>
                <tr v-for="(item, index) in list" :key="index">
                    <td class="label">{{ item.label }}:</td>
                    <td :class="{
                        red: item.red
                    }">
                        <p v-for="(text, i) in item.texts" :key="i">
                            {{ text }}
                        </p>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {

    props: {

        list: Array
        
    }
    
};
</script>

<style scoped lang="less">
.reo-plan-message{
    padding: 0.3rem;
    background-color: #F7F8F9;
    border-radius: 0.08rem;
    font-size: 0.16rem;
    @media @mobile{
        padding: 0.6rem 0.3rem;
        font-size: 0.26rem;
        border-radius: 0.18rem;
    }
    .label{
        font-weight: 500;
        padding-right: 0.4rem;
        white-space: nowrap;
        @media @mobile{
            padding-right: 0.6rem;
        }
    }
    tr{
        text-align: left;
        vertical-align: top;
    }
    tr+tr td{
        padding-top: 0.15rem;
        @media @mobile{
            padding-top: 0.2rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/planMessage.vue